import {HttpClient, HttpResponse} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';
import {environment} from "@environments/environment";
import {Observable} from 'rxjs';
import {PageableParams} from '@core/models/pageable-params';

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {
  private uri = environment.api.uri.concat('documentos')
  private http = inject(HttpClient)

  import(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<void>(this.uri, formData);
  }

  exportWithFilters(documentType: 'EXCEL' | 'PARQUET', filters: Record<string, unknown>): Observable<HttpResponse<Blob>> {
    let payload = new PageableParams();
    payload.filters = {...filters, documentType: documentType};
    const params = payload.onlyFiltersToQueryString();

    return this.http.get(`${this.uri}/filter?${params}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  downloadModelo(): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.uri}/modelo`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
